import { post } from "./api"

export const saveShare = (network, id) => {
  post("/share/viralshare", {
    id,
    network,
  })
}

export const postToLinkedIn = (link, id) => {
  if (window.IN && window.IN.UI) {
    window.IN.UI.Share().params({ url: link }).place()
    saveShare("linkedin", id)
    return
  }
}

const getShareUrlByNetwork = (type, slideshow) => {
  switch (type) {
    case "facebook":
      return slideshow.facebook_post_url
    case "twitter":
      return slideshow.twitter_post_url
    case "linkedin":
      return slideshow.linkedin_post_url
  }
}

export const openSharePopup = (type, slideshow) => {
  // Default width and height of popup
  let width = 626
  let height = 436

  const shareURL = getShareUrlByNetwork(type, slideshow)
  console.log(shareURL)

  // Following a viral share, we save it to the viral share database. For
  // networks other than facebook, we do not track *completed* shares, and
  // so for them we need to call saveShare to save the viral share in the
  // viral share DB as soon as we get the initial click. For facebook, we
  // insert a row into the viral share db on successful completion of the
  // share, so we do not do it here.
  if (type === "linkedin") {
    postToLinkedIn(shareURL, slideshow.slideshow_id)
  }

  window.open(shareURL, "shareDialog", "width=" + width + ",height=" + height)
  saveShare(type, slideshow.slideshow_id)
}
